"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const spacing_1 = require("./spacing");
class ContentAligner {
    constructor(layout) {
        this.layout = layout;
        this.totalCrossAxisSize = 0;
        this.init();
    }
    init() {
        this.totalCrossAxisSize = this.calcTotalCrossAxisSize();
    }
    get lines() {
        return this.layout.getLines();
    }
    align() {
        const crossAxisSize = this.layout.crossAxisSize;
        const remainingSpace = crossAxisSize - this.totalCrossAxisSize;
        const { spacingBefore, spacingBetween } = this.getSpacing(remainingSpace);
        const lines = this.lines;
        const mode = this.layout.container.alignContent;
        let growSize = 0;
        if (mode === "stretch" && lines.length && remainingSpace > 0) {
            growSize = remainingSpace / lines.length;
        }
        let currentPos = spacingBefore;
        for (let i = 0, n = lines.length; i < n; i++) {
            const crossAxisLayoutOffset = currentPos;
            const aligner = lines[i].createItemAligner();
            const finalCrossAxisLayoutSize = lines[i].crossAxisLayoutSize + growSize;
            aligner.setCrossAxisLayoutSize(finalCrossAxisLayoutSize);
            aligner.setCrossAxisLayoutOffset(crossAxisLayoutOffset);
            aligner.align();
            if (aligner.getRecursiveResizeOccured()) {
                lines[i].setItemPositions();
            }
            currentPos += finalCrossAxisLayoutSize;
            currentPos += spacingBetween;
        }
    }
    getTotalCrossAxisSize() {
        return this.totalCrossAxisSize;
    }
    calcTotalCrossAxisSize() {
        const lines = this.lines;
        let total = 0;
        for (let i = 0, n = lines.length; i < n; i++) {
            const line = lines[i];
            total += line.crossAxisLayoutSize;
        }
        return total;
    }
    getSpacing(remainingSpace) {
        const mode = this.layout.container.alignContent;
        const numberOfItems = this.lines.length;
        return spacing_1.getSpacing(mode, numberOfItems, remainingSpace);
    }
}
exports.ContentAligner = ContentAligner;
//# sourceMappingURL=ContentAligner.js.map